const baseUrl = "https://qrgreet.com/";
// const globalServerURL = 'http://10.0.2.2:8000/api/';

export const api = {
  ACTIVE_GUEST_CODE: `${baseUrl}qr/guest/`,
  ACTIVE_USER_CODE: `${baseUrl}qr/`,
  REVIEW: `${baseUrl}qr/review/`,
  GALLERY: `${baseUrl}apiv1/rec`,
};
